import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const { color } = theme;

const name: CSSObject = {
  fontSize: 15,
  fontWeight: 600,
  color: color.text,
  span: {
    marginLeft: 4,
    fontWeight: 400,
    color: color.textSub,
  },
};

const status = (blocked: boolean): CSSObject => ({
  fontSize: 13,
  fontWeight: 500,
  color: blocked ? color.error : color.success,
});

export { name, status };
